export const films = [
  {
    id: "interstellar-remaster",
    title: "星际穿越·穹顶重制版",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20cosmic%20background%20with%20glowing%20teal%20nebula%2C%20a%20lone%20astronaut%20silhouette%20before%20a%20colossal%20glowing%20wormhole%2C%20dramatic%20lighting%2C%20premium%20film%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus%2C%20professional%20entertainment%20poster%20design&width=600&height=900&seq=qiubu-poster-01&orientation=portrait",
    director: "克里斯托弗·诺兰",
    cast: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦"],
    genres: ["科幻", "剧情"],
    year: 2014,
    rating: 9.4,
    duration: 169,
    tags: ["球幕技术", "IMAX 重制", "杜比全景声"],
    synopsis: "在地球濒临枯萎的时代，一支探险队穿越虫洞，为人类寻找新的家园。穹顶重制版以整片星空包裹观众，让每一次引力弹弓都触手可及。",
    description: "《星际穿越·穹顶重制版》是我们为穹顶放映厅特别修复的版本。借助 8K 激光球幕投影与 12.1 声道环绕系统，观众将置身于黑洞吸积盘的中央，感受时间与引力的拉扯。影片中对相对论时间膨胀的呈现，在球幕的全视野包裹下被重新定义。",
    trailerUrl: "",
    featured: true,
    popularity: 98,
    releaseDate: "2026-09-18",
  },
  {
    id: "deep-sea-odyssey",
    title: "深海奇境",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20underwater%20background%20with%20glowing%20cyan%20bioluminescent%20creatures%2C%20a%20diver%20silhouette%20descending%20into%20a%20dramatic%20deep%20sea%20trench%2C%20premium%20documentary%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus%2C%20professional%20entertainment%20poster%20design&width=600&height=900&seq=qiubu-poster-02&orientation=portrait",
    director: "陈曦",
    cast: ["配音：李立宏"],
    genres: ["纪录片"],
    year: 2026,
    rating: 9.1,
    duration: 52,
    tags: ["球幕技术", "3D效果", "自然探索"],
    synopsis: "潜入海平面以下一万米，见证人类从未抵达的深海奇观。球幕视角让环绕四周的深海水压与荧光生物扑面而来。",
    description: "本片由海洋科考团队历时四年拍摄，全程 8K 水下摄影。在穹顶影厅中，观众仿佛被装进一颗透明的深潜球舱，四周皆是游弋的深海生物与热液喷口。导览式解说带你了解深海生态与地球生命起源。",
    trailerUrl: "",
    featured: true,
    popularity: 92,
    releaseDate: "2026-10-02",
  },
  {
    id: "aurora-journey",
    title: "极光之旅",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20polar%20night%20sky%20background%20with%20vivid%20green%20and%20orange%20aurora%20curtains%2C%20a%20small%20figure%20standing%20on%20frozen%20ground%20gazing%20up%2C%20premium%20documentary%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus%2C%20professional%20entertainment%20poster%20design&width=600&height=900&seq=qiubu-poster-03&orientation=portrait",
    director: "艾米莉亚·诺德",
    cast: ["旁白：大卫·爱登堡"],
    genres: ["纪录片"],
    year: 2026,
    rating: 8.9,
    duration: 46,
    tags: ["球幕技术", "自然探索", "全视野"],
    synopsis: "追随太阳风抵达地球两极的轨迹，在穹顶之下迎接一场 360 度的极光盛宴。",
    description: "影片横跨冰岛、挪威与加拿大黄刀镇，用延时与高速摄影记录极光的每一次舞动。穹顶投影将极光从地平线一直延伸到头顶正上方，让观众真正置身于光幕之中。",
    trailerUrl: "",
    featured: true,
    popularity: 87,
    releaseDate: "2026-09-26",
  },
  {
    id: "mars-dawn",
    title: "火星黎明",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20space%20background%20with%20rust%20orange%20mars%20planet%20surface%2C%20a%20human%20base%20dome%20glowing%20on%20the%20horizon%2C%20dramatic%20sunrise%20lighting%2C%20premium%20sci%20fi%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus&width=600&height=900&seq=qiubu-poster-04&orientation=portrait",
    director: "瑞德利·周",
    cast: ["王砚辉", "张子枫", "欧豪"],
    genres: ["科幻", "剧情"],
    year: 2026,
    rating: 8.7,
    duration: 138,
    tags: ["球幕技术", "3D效果", "杜比全景声"],
    synopsis: "第一批火星定居者在红色荒原上迎来第一个黎明，也迎来了生存与理想的抉择。",
    description: "影片以近未来火星殖民为背景，球幕版特别强化了火星沙尘暴的临场感——当风暴席卷穹顶，观众能感受到整个空间被红色尘埃填满。这是一次关于孤独、希望与人类未来的沉思。",
    trailerUrl: "",
    featured: false,
    popularity: 84,
    releaseDate: "2026-10-10",
  },
  {
    id: "planet-earth-dome",
    title: "地球脉动·穹顶版",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20sky%20background%20with%20golden%20green%20landscape%20curving%20into%20planet%20horizon%2C%20flocks%20of%20birds%20and%20herds%20migrating%2C%20premium%20nature%20documentary%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus&width=600&height=900&seq=qiubu-poster-05&orientation=portrait",
    director: "BBC 自然史团队",
    cast: ["旁白：大卫·爱登堡"],
    genres: ["纪录片"],
    year: 2025,
    rating: 9.3,
    duration: 58,
    tags: ["球幕技术", "自然探索", "全视野"],
    synopsis: "从赤道雨林到极地冰原，穹顶版把整颗地球的呼吸装进你的视野。",
    description: "这是经典自然纪录片系列的穹顶特别剪辑。镜头被重新拼接为球幕视角，观众不再是旁观者，而是悬浮在地球表面之上的旅人，见证生命迁徙的宏大史诗。",
    trailerUrl: "",
    featured: true,
    popularity: 90,
    releaseDate: "2026-08-30",
  },
  {
    id: "city-of-time",
    title: "时光倒流的城市",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20night%20city%20skyline%20background%20with%20glowing%20amber%20windows%20and%20floating%20clock%20fragments%2C%20a%20lone%20figure%20walking%20a%20wet%20reflective%20street%2C%20premium%20drama%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus&width=600&height=900&seq=qiubu-poster-06&orientation=portrait",
    director: "毕赣",
    cast: ["汤唯", "黄觉", "辛芷蕾"],
    genres: ["剧情", "爱情"],
    year: 2025,
    rating: 8.4,
    duration: 124,
    tags: ["球幕技术", "长镜头", "沉浸叙事"],
    synopsis: "一座被时间遗忘的城市里，一名钟表匠试图让所有失去的瞬间重新流动。",
    description: "影片以诗意长镜头著称，穹顶版将城市的雨夜与霓虹包裹观众四周，长镜头中的每一次转身都能看到完整的城市全景。这是一部关于记忆与告别的作品。",
    trailerUrl: "",
    featured: false,
    popularity: 76,
    releaseDate: "2026-07-15",
  },
  {
    id: "edge-of-the-cosmos",
    title: "宇宙边缘",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20cosmos%20background%20with%20spiral%20galaxy%20and%20vivid%20violet%20teal%20starlight%2C%20a%20tiny%20spaceship%20trailing%20light%20toward%20a%20bright%20core%2C%20premium%20sci%20fi%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus&width=600&height=900&seq=qiubu-poster-07&orientation=portrait",
    director: "丹尼斯·维伦纽瓦",
    cast: ["瑞恩·高斯林", "丽贝卡·弗格森"],
    genres: ["科幻"],
    year: 2026,
    rating: 8.8,
    duration: 146,
    tags: ["球幕技术", "3D效果", "IMAX 重制"],
    synopsis: "当宇宙的边界开始收缩，一名领航员必须找到回到中心的唯一航线。",
    description: "影片以硬科幻设定与极简视觉风格闻名。球幕版本强化了星际航行的方向感缺失体验，让观众与主角一同迷失在无垠的星海之中。",
    trailerUrl: "",
    featured: false,
    popularity: 85,
    releaseDate: "2026-10-05",
  },
  {
    id: "age-of-dinosaurs",
    title: "恐龙纪元",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20prehistoric%20jungle%20background%20with%20volcanic%20orange%20glow%2C%20a%20giant%20dinosaur%20silhouette%20emerging%20from%20mist%2C%20premium%20documentary%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus%2C%20dramatic%20lighting&width=600&height=900&seq=qiubu-poster-08&orientation=portrait",
    director: "古生物影像实验室",
    cast: ["旁白：周涛"],
    genres: ["纪录片", "冒险"],
    year: 2026,
    rating: 8.6,
    duration: 44,
    tags: ["球幕技术", "3D效果", "自然探索"],
    synopsis: "穿越一亿年，在穹顶之下与史前巨兽面对面。",
    description: "基于最新化石发现重建的恐龙世界，配合球幕的包围式视角，让霸王龙的脚步从观众背后传来。影片兼顾科学严谨与沉浸刺激，适合全家共同观看。",
    trailerUrl: "",
    featured: false,
    popularity: 88,
    releaseDate: "2026-09-12",
  },
  {
    id: "city-in-the-clouds",
    title: "云端之城",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20sky%20background%20with%20sunlit%20floating%20city%20above%20a%20sea%20of%20clouds%2C%20slender%20bridges%20and%20warm%20amber%20lights%2C%20premium%20fantasy%20drama%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus&width=600&height=900&seq=qiubu-poster-09&orientation=portrait",
    director: "宫崎骏致敬团队",
    cast: ["配音：张韶涵", "彭昱畅"],
    genres: ["剧情", "动画"],
    year: 2025,
    rating: 8.3,
    duration: 108,
    tags: ["球幕技术", "全视野", "亲子"],
    synopsis: "一座漂浮在云海之上的城市，藏着一段关于勇气与告别的温柔旅程。",
    description: "手绘风格的动画在穹顶之上展开，云海会一直延伸到观众的头顶。适合亲子观影，球幕版让童话世界变得真实可触。",
    trailerUrl: "",
    featured: false,
    popularity: 72,
    releaseDate: "2026-06-20",
  },
  {
    id: "quantum-drift",
    title: "量子迷航",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20background%20with%20glowing%20cyan%20and%20orange%20quantum%20energy%20particles%2C%20a%20fragmented%20human%20figure%20dissolving%20into%20light%2C%20premium%20sci%20fi%20thriller%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus&width=600&height=900&seq=qiubu-poster-10&orientation=portrait",
    director: "郭帆",
    cast: ["吴京", "刘德华", "沙溢"],
    genres: ["科幻", "悬疑"],
    year: 2026,
    rating: 8.5,
    duration: 132,
    tags: ["球幕技术", "杜比全景声", "3D效果"],
    synopsis: "一次量子实验失控，科学家在多个平行自我之间寻找回家的路。",
    description: "影片以多线叙事与视觉奇观著称，球幕版将平行世界的重叠以画面分层的方式铺满整个视野，观众需要转动身体才能看全信息，是沉浸式叙事的代表作。",
    trailerUrl: "",
    featured: false,
    popularity: 89,
    releaseDate: "2026-10-11",
  },
  {
    id: "age-of-exploration",
    title: "大航海时代",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20ocean%20storm%20background%20with%20a%20tall%20sailing%20ship%20riding%20huge%20waves%2C%20warm%20amber%20lantern%20lights%2C%20dramatic%20clouds%2C%20premium%20historical%20documentary%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus&width=600&height=900&seq=qiubu-poster-11&orientation=portrait",
    director: "历史影像修复团队",
    cast: ["旁白：濮存昕"],
    genres: ["纪录片", "历史"],
    year: 2025,
    rating: 8.2,
    duration: 50,
    tags: ["球幕技术", "全视野", "亲子"],
    synopsis: "跟随古代航海家的罗盘，在穹顶之中经历一场横跨大洋的风暴之旅。",
    description: "影片重现了大航海时代的航线与港口。球幕版让海浪从四周涌上视野边缘，观众如同站在摇晃的甲板之上，感受人类探索未知的勇气。",
    trailerUrl: "",
    featured: false,
    popularity: 70,
    releaseDate: "2026-05-08",
  },
  {
    id: "promise-of-the-stars",
    title: "星海之约",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20navy%20night%20sky%20over%20a%20calm%20dark%20lake%2C%20countless%20stars%20reflected%20on%20the%20water%2C%20two%20small%20figures%20standing%20on%20a%20pier%2C%20premium%20romance%20drama%20key%20art%2C%20moody%20atmospheric%20composition%2C%20sharp%20focus&width=600&height=900&seq=qiubu-poster-12&orientation=portrait",
    director: "许鞍华",
    cast: ["周冬雨", "刘昊然"],
    genres: ["爱情", "剧情"],
    year: 2026,
    rating: 8.1,
    duration: 118,
    tags: ["球幕技术", "沉浸叙事", "全视野"],
    synopsis: "两个多年未见的人，在星空下重逢，兑现一次迟到十年的约定。",
    description: "影片以细腻的情感与克制的镜头语言见长。球幕版将夏夜星空完整覆盖观众头顶，让最安静的告白拥有了最宏大的背景。",
    trailerUrl: "",
    featured: false,
    popularity: 79,
    releaseDate: "2026-09-30",
  },
];